export const DE_OPENING_QUOTE = '„';
export const DE_CLOSING_QUOTE = '“';
